import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { SchedulerOwningEntityType } from '@/components/integration/nylas/scheduler/types'
import { QUERY_KEYS } from '@/lib/queryKeys'
import publicMeetingTypeService from '@/lib/services/publicMeetingTypeService'

function buildQueryOptions(
  type: SchedulerOwningEntityType,
  owningEntityId: number | string,
) {
  return {
    staleTime: 5 * 60 * 1000,
    queryKey: QUERY_KEYS.publicMeetingType(type, owningEntityId),
    queryFn: () => publicMeetingTypeService.get(type, owningEntityId),
  }
}

export default function usePublicMeetingTypeQuery(
  type: SchedulerOwningEntityType,
  owningEntityId: number | string,
  options: { enabled?: boolean } = {},
) {
  return useQuery({
    ...buildQueryOptions(type, owningEntityId),
    enabled: options.enabled ?? true,
  })
}

export function usePrefetchPublicMeetingType(
  type: SchedulerOwningEntityType,
  owningEntityId: number | string,
) {
  const queryClient = useQueryClient()

  return useCallback(
    () =>
      queryClient.prefetchQuery({
        ...buildQueryOptions(type, owningEntityId),
      }),
    [queryClient, type, owningEntityId],
  )
}
